import { Box } from '@chakra-ui/react';

interface IProps {
	hourHeightInPixels: number;
}
export function HourTick(props: IProps) {
	return (
		<Box
			as="span"
			borderBottomColor="ui-element-divider"
			borderBottomWidth={0.5}
			borderTopColor="transparent"
			borderTopWidth={0.5}
			h={`${props.hourHeightInPixels}px`}
			display="flex"
			color="gray.400"
			px={1}
			justifyContent="flex-start"
			alignItems="flex-start"
			overflow="visible"
		/>
	);
}
